import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '../../../../../axios/axiosBaseQuery';
import { Report } from '../report.model';
import { Group } from '../../../../../redux/groups/api/group.model';
import { Merchandiser } from '../../composableDevice/model/Merchandiser.model';
import Util from '../../../../../util/Util';

type ReportsResponse = Report[];

interface DownloadReportsArgs {
  reports: string[];
  formats: string[];
}

export interface ReportCreateForm {
  stores: Group[];
  initialPeriod: string;
  endPeriod: string;
  merchandisers: Merchandiser[];
  topics: string[];
  formats: string[];
}
const ReportBaseURL = new Util().getReportURL();
// TODO Update the endpoint to match the actual endpoint
export const ReportsGenerationAPI = createApi({
  reducerPath: 'reports_generation',
  tagTypes: ['add-report'],
  baseQuery: axiosBaseQuery({ baseUrl: ReportBaseURL }),
  endpoints: (build) => ({
    getReports: build.query<ReportsResponse, string>({
      query: (cityId) => ({
        url: `/${cityId}`,
        invalidatesTags: ['add-report'],
      }),
    }),
    downloadReports: build.query<void, DownloadReportsArgs>({
      query: (args: DownloadReportsArgs) => ({
        url: `/download`,
        method: 'POST',
        args,
      }),
    }),
    generateReport: build.query<void, ReportCreateForm>({
      query: (args: ReportCreateForm) => ({
        url: `/generate`,
        method: 'POST',
        args,
      }),
    }),
  }),
});

export const {
  useGetReportsQuery,
  useLazyDownloadReportsQuery,
  useLazyGenerateReportQuery,
} = ReportsGenerationAPI;
